// ExportPDF.js (Güncelleme)
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const generatePDF = async (data = {}) => {
    try {
        const invoiceForm = document.getElementById('invoice_form');
        if (!invoiceForm) {
            throw new Error('Form content not found');
        }

        const opt = {
            margin: 10,
            filename: `Teklif-${data.invoiceNo || 'download'}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { 
                scale: 2,
                useCORS: true,
                logging: false
            },
            jsPDF: { 
                unit: 'mm', 
                format: 'a4', 
                orientation: 'portrait' 
            }
        };

        const canvas = await html2canvas(invoiceForm, opt.html2canvas);
        const imgData = canvas.toDataURL('image/jpeg', 1.0);
        const pdf = new jsPDF(opt.jsPDF);

        const imgWidth = 210;
        const pageHeight = 297;
        const imgHeight = canvas.height * imgWidth / canvas.width;
        let heightLeft = imgHeight;
        let position = 0;

        pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
        }

        pdf.save(opt.filename);

    } catch (error) {
        console.error('PDF oluşturma hatası:', error);
        throw error;
    }
};

export const usePDFExport = () => {
    return { exportToPDF: generatePDF };
};

export default generatePDF;